// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__G0abU","header":"Menu_header__5YtFe","body":"Menu_body__8eQTX","footer":"Menu_footer__GSKT1","cancel":"Menu_cancel__oiVk7"};